import { c as _c } from "react/compiler-runtime";
import { useLocale } from "@repo/design-system/hooks/use-locale";
import Script from "next/script";
export function UserCentrics() {
  const $ = _c(2);
  const locale = useLocale();
  const t0 = locale === "sv" ? "en" : locale;
  let t1;
  if ($[0] !== t0) {
    t1 = <Script id="usercentrics-cmp" src="https://app.usercentrics.eu/browser-ui/latest/loader.js" data-settings-id="bRVPUaxVZg67bi" data-language={t0} async={true} />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}